<div class="text-deadlines" *ngIf="isString" [innerHTML]="deadlines">
</div>
<ng-container *ngIf="!isString && deadlines">
  <ng-container *ngFor="let rule of deadlineRules">
    <div *ngIf="rule.hasPickupOrDelivery">
      <ng-container *ngIf="!rule.orderOnDay && rule.orderDaysBeforeCount">
        <span translate [translateParams]="rule">orderProcess.deadlines.rangeDaysRuleInfo</span>
      </ng-container>
      <ng-container *ngIf="rule.orderOnDay && rule.orderDaysBeforeCount">
        <span translate [translateParams]="rule">orderProcess.deadlines.singleDayRuleInfo</span>
      </ng-container>
      <ng-container *ngIf="!rule.orderDaysBeforeCount">
        <span translate [translateParams]="rule">orderProcess.deadlines.sameDayRuleInfo</span>
      </ng-container>
    </div>

<!--    <div *ngIf="!rule.hasPickupOrDelivery">-->
<!--      <span translate [translateParams]="rule">orderProcess.deadlines.dayOffRuleInfo</span>-->
<!--    </div>-->
  </ng-container>
</ng-container>
